export const SET_USER_STATE = "SET_USER_STATE";
export const SET_LANDING_PAGES = "SET_LANDING_PAGES";
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
export const SET_ACTIVE_TEMPLATE_CONTENT = "SET_ACTIVE_TEMPLATE_CONTENT";
export const SET_SHARE_DATA = "SET_SHARE_DATA";
export const SET_STATISTICS = "SET_STATISTICS";
export const SET_PAGE_INFO = "SET_PAGE_INFO";
